import { Image as ImageIcon, ImageOff } from "lucide-react";

export default function ImageToggle({ show, onToggle, testId = "image-toggle" }) {
  return (
    <button
      type="button"
      onClick={() => onToggle(!show)}
      data-testid={testId}
      aria-pressed={show}
      title={show ? "Hide picture hint" : "Show picture hint"}
      className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full font-bold text-sm transition-all border-2 ${
        show
          ? "bg-[#FBBF24] text-[#1E1B4B] border-transparent shadow-[0_3px_0_#B45309]"
          : "bg-white text-[#1E1B4B] border-blue-200 hover:bg-blue-50"
      }`}
    >
      {show ? <ImageIcon className="w-4 h-4" strokeWidth={3} /> : <ImageOff className="w-4 h-4" strokeWidth={3} />}
      {show ? "Picture: on" : "Picture: off"}
    </button>
  );
}
